import { Injectable } from '@angular/core';
import {
  ECAAP_PROD_ENDPOINT,
  ECAAP_NON_PROD_ENDPOINT,
  ECAAP_NON_PROD_EXTERNAL_ENDPOINT,
} from 'src/app/constants/NextGenConstants';

@Injectable({
  providedIn: 'root',
})
export class NextGenUtilService {
  // Uses the provided hostname to determine which ecaap endpoint should be used
  getEcaapUrl(hostname: string): string {
    if (hostname.endsWith('.fidelity.com')) {
      if (hostname.includes('xq1')) {
        return ECAAP_NON_PROD_EXTERNAL_ENDPOINT;
      }
      return ECAAP_PROD_ENDPOINT;
    }
    return ECAAP_NON_PROD_ENDPOINT;
  }
}
